import React, { Suspense, lazy } from 'react';
import { StickyHeader } from '../components/StickyHeader';
import { HeroSection } from '../components/HeroSection';
import { TruthSection } from '../components/TruthSection';
const WarningSigns = lazy(() => import('../components/WarningSigns').then(m => ({
  default: m.WarningSigns
})));
const NobodyToldYou = lazy(() => import('../components/NobodyToldYou').then(m => ({
  default: m.NobodyToldYou
})));
const WhatItIsNot = lazy(() => import('../components/WhatItIsNot').then(m => ({
  default: m.WhatItIsNot
})));
const NoBrainSection = lazy(() => import('../components/NoBrainSection').then(m => ({
  default: m.NoBrainSection
})));
const ObjectionsSection = lazy(() => import('../components/ObjectionsSection').then(m => ({
  default: m.ObjectionsSection
})));
const UrgencySection = lazy(() => import('../components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const FinalCTA = lazy(() => import('../components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
function SectionFallback() {
  return <div className="min-h-[200px] bg-[#0A0A0A]" data-id="element-361" />;
}
export function SalesPage() {
  return <div className="min-h-screen bg-[#0A0A0A] text-[#FAF7F2] font-sans selection:bg-[#C5A55A] selection:text-white" data-id="element-362">
      <StickyHeader data-id="element-363" />
      <main data-id="element-364">
        <HeroSection data-id="element-365" />
        <TruthSection data-id="element-366" />
        <Suspense fallback={<SectionFallback data-id="element-368" />} data-id="element-367">
          <WarningSigns data-id="element-369" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-371" />} data-id="element-370">
          <NobodyToldYou data-id="element-372" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-374" />} data-id="element-373">
          <WhatItIsNot data-id="element-375" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-377" />} data-id="element-376">
          <NoBrainSection data-id="element-378" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-380" />} data-id="element-379">
          <ObjectionsSection data-id="element-381" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-383" />} data-id="element-382">
          <UrgencySection data-id="element-384" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-386" />} data-id="element-385">
          <FinalCTA data-id="element-387" />
        </Suspense>
      </main>

      <footer className="bg-[#050505] py-10 text-center border-t border-[#C5A55A]/10" data-id="element-388">
        <div className="max-w-3xl mx-auto px-4" data-id="element-389">
          <div className="w-12 h-px bg-[#C5A55A]/30 mx-auto mb-6" data-id="element-390"></div>
          <p className="text-[#FAF7F2]/30 text-xs" data-id="element-391">
            © 2024 Inmersión Pareja. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}